export enum ShrimpTypeEnum{
    GOOD = 'GOOD',
    DEFECT = 'DEFECT'
}